export const getEnvironment = () => {
  let env = 'development';

  if (document.URL.includes('parlay-ui-staging-2.')) {
    env = 'staging_two';
  }

  if (document.URL.includes('parlay-ui-staging.')) {
    env = 'staging';
  }

  if (document.URL.includes('go.parlayideas')) {
    env = 'production';
  }
  console.log('PARLAY', env);
  return env;
};

const configs = {
  development: {
    apiURL: 'http://localhost:9000',
    uiURL: 'http://localhost:8080',
    universeURL: 'http://localhost:3000',
  },
  staging: {
    apiURL:
      process.env.REVIEW_APP_API || 'https://parlay-api-staging.herokuapp.com',
    uiURL: 'https://parlay-ui-staging.herokuapp.com',
    universeURL: 'https://parlay-universe-staging.herokuapp.com',
  },
  staging_two: {
    apiURL:
      process.env.REVIEW_APP_API ||
      'https://parlay-api-staging-2.herokuapp.com',
    uiURL: 'https://parlay-ui-staging-2.herokuapp.com',
    universeURL: 'https://parlay-universe-staging-2.herokuapp.com',
  },
  production: {
    apiURL: 'https://parlay-api.herokuapp.com',
    uiURL: 'https://go.parlayideas.com',
    universeURL: 'http://universe.parlayideas.com',
  },
};

export const environment = getEnvironment();
export const envConfigs = configs[environment];
export default configs[environment];



// WEBPACK FOOTER //
// ./src/app/services/apiConfigs.js